"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCurrentRateWindow = exports.getRateWindow = exports.getCurrentRateWindow = exports.formatRateWindow = void 0;
const date_fns_1 = require("date-fns");
const utils_1 = require("./utils");
function formatRateWindow(date) {
    return (0, date_fns_1.format)(date, 'LLL, Mo h:00 aaa');
}
exports.formatRateWindow = formatRateWindow;
function getCurrentRateWindow() {
    return (0, date_fns_1.startOfHour)(new Date());
}
exports.getCurrentRateWindow = getCurrentRateWindow;
function getRateWindow(date) {
    return (0, date_fns_1.startOfHour)(date);
}
exports.getRateWindow = getRateWindow;
function isCurrentRateWindow(date) {
    if (!date)
        return false;
    let source = ((0, utils_1.isString)(date)) ? Date.parse(date) : date;
    let current = getCurrentRateWindow();
    let compare = getRateWindow(source);
    return (0, date_fns_1.isEqual)(current, compare);
}
exports.isCurrentRateWindow = isCurrentRateWindow;
